import { Textarea, Label } from '@fluentui/react-components';
import { useDraftStore } from '../../stores/draftStore';

export function DraftEditor() {
  const { draft, setDraft } = useDraftStore();

  if (!draft) return null;

  const handleBodyChange = (value: string) => {
    setDraft({
      ...draft,
      body: value,
    });
  };

  const handleSubjectChange = (value: string) => {
    setDraft({
      ...draft,
      subject: value,
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
      {/* Subject */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Label size="small" style={{ color: 'var(--color-gray-600)' }}>
          Subject
        </Label>
        <Textarea
          value={draft.subject}
          onChange={(_e, data) => handleSubjectChange(data.value)}
          resize="none"
          style={{ minHeight: '40px' }}
        />
      </div>

      {/* Body */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
        <Label size="small" style={{ color: 'var(--color-gray-600)' }}>
          Draft Reply
        </Label>
        <Textarea
          value={draft.body}
          onChange={(_e, data) => handleBodyChange(data.value)}
          resize="vertical"
          style={{
            minHeight: '200px',
            fontFamily: "'Segoe UI', sans-serif",
            fontSize: '14px',
            lineHeight: '1.6',
          }}
        />
      </div>
    </div>
  );
}
